import React, { useRef } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import SearchGlass from '@/components/commons/icons/SearchGlass';
import CloseButton from '@/components/commons/icons/CloseButton';

import styles from './Searchbar.module.css';

function Searchbar({
    setSearchTerm,
    searchTerm,
    placeholder = 'Search',
}) {
    const inputRef = useRef(null);
    const debounced = useDebouncedCallback(
        (value) => {
            setSearchTerm(value);
        },
        250, // delay in ms
    );

    const clearSearch = () => {
        setSearchTerm('');
        if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.value = '';
        }
    };

    const focusSearch = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return (
        <div className={styles.searchBar}>
            <input
                ref={inputRef}
                type="text"
                name="searchBoxInput"
                className={styles.input}
                placeholder={placeholder}
                onChange={(e) => debounced(e.target.value)}
            />
            <div className={styles.inputIconHolder}>
                {searchTerm ? (
                    <CloseButton className={styles.cancelButton} onClick={clearSearch} />
                ) : (
                    <SearchGlass className={styles.searchIcon} onClick={focusSearch} />
                )}
            </div>
        </div>
    );
}

export default Searchbar;
